class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    if (this.querySelector('form')) {
      const facetForm = this.querySelector('form');
      if (facetForm.id !== 'FacetFiltersFormMobile') {
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      } else {
        facetForm.addEventListener('input', (event) => {
          const target = event.target;
          if (target.type === 'checkbox' || target.type === 'radio') {
            const label = target.closest('label') || target.closest('.facets__label') || target.closest('.facet-checkbox');
            if (label) {
              label.classList.toggle('active', target.checked);
            }
          }
        });
      }
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const fwd = document.querySelector('#FacetsWrapperDesktop');
    if (fwd) {
      let totalFilterHeight = fwd.offsetHeight;
      document.documentElement.style.setProperty('--filter-height', `${totalFilterHeight}px`);
    }

    const pgc = document.querySelector('#ProductGridContainer');
    if (pgc) {
      let totalGridHeight = pgc.offsetHeight;
      document.documentElement.style.setProperty('--productgrid-height', `${totalGridHeight}px`);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(hidden = true) {
    document.querySelectorAll('facet-remove').forEach((element) => {
      element.classList.toggle('hidden', hidden);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const pgc = document.getElementById('ProductGridContainer');
    if (pgc) {
      const collection = pgc.querySelector('.collection');
      if (collection) collection.classList.add('loading');
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    const savedLayout = localStorage.getItem('productLayout');
    if (savedLayout) {
      applyLayout(savedLayout);
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    const fwd = document.querySelector('#FacetsWrapperDesktop');
    if (fwd) {
      let totalFilterHeight = fwd.offsetHeight;
      document.documentElement.style.setProperty('--filter-height', `${totalFilterHeight}px`);
    }
    const pgc = document.querySelector('#ProductGridContainer');
    if (pgc) {
       let totalGridHeight = pgc.offsetHeight;
       document.documentElement.style.setProperty('--productgrid-height', `${totalGridHeight}px`);
    }

    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    const hasActiveFilter = FacetFiltersForm.hasActiveFilter(window.location.search);

    FacetFiltersForm.toggleActiveFacets(!hasActiveFilter);
  }

  static hasActiveFilter(queryString) {
    const params = new URLSearchParams(queryString);
    const defaultSort = document.querySelector('[data-default-sort]')?.dataset.defaultSort;

    for (const [key, value] of params.entries()) {
      if (key.startsWith('filter.') && value !== '') {
        return true;
      }
    }

    const currentSort = params.get('sort_by');
    if (currentSort && defaultSort && currentSort !== defaultSort) {
      return true;
    }

    return false;
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.facets-vertical-changelayout'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElements = html.querySelectorAll(selector);
      const targetElements = document.querySelectorAll(selector);
      if (sourceElements.length > 0 && targetElements.length > 0) {
        targetElements.forEach((el, index) => {
          if (sourceElements[index]) {
            el.innerHTML = sourceElements[index].innerHTML;
          }
        });
      }
    });

    const mobileDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    if (mobileDrawer) mobileDrawer.bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  static initChangeLayout() {
    document.addEventListener('click', (event) => {
      const el = event.target.closest('[data-change-layout="true"]');
      if (!el) return;
      
      event.preventDefault();

      const productGrid = document.querySelector('#product-grid');
      if (!productGrid) return;

      if (el.classList.contains('facets-vertical-changelayout__option-1')) {
        applyLayout('option-1');
      }

      if (el.classList.contains('facets-vertical-changelayout__option-2')) {
        applyLayout('option-2');
      }

      if (el.classList.contains('facets-vertical-changelayout__option-3')) {
        applyLayout('option-3');
      }

      if (el.classList.contains('facets-vertical-changelayout__option-4')) {
        applyLayout('option-4');
      }

      if (el.classList.contains('facets-vertical-changelayout__option-5')) {
        applyLayout('option-5');
      }

      const pgc = document.querySelector('#ProductGridContainer');
      if (pgc) {
        let totalGridHeight = pgc.offsetHeight;
        document.documentElement.style.setProperty('--productgrid-height', `${totalGridHeight}px`);
      }
    });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const fwd = document.querySelector('#FacetsWrapperDesktop');
    if (fwd) {
      let totalFilterHeight = fwd.offsetHeight;
      document.documentElement.style.setProperty('--filter-height', `${totalFilterHeight}px`);
    }
    const pgc = document.querySelector('#ProductGridContainer');
    if (pgc) {
      let totalGridHeight = pgc.offsetHeight;
      document.documentElement.style.setProperty('--productgrid-height', `${totalGridHeight}px`);
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form'); 
    if (event?.srcElement?.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
      document.querySelector('.mobile-facets__close').click();
    } else {
      const forms = [];
      const currentForm = event.target.closest('form');
      const isMobile = currentForm.id === 'FacetFiltersFormMobile';

      if (isMobile) {
        forms.push(this.createSearchParams(currentForm));
        document.querySelector('.mobile-facets__close').click();
      } else {
        sortFilterForms.forEach((form) => {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        });
      }
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.initChangeLayout();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.modernRange = this.querySelector('.price-range');

    if (this.modernRange) {
      this.setupModernRange();
      return;
    }

    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onLegacyRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setLegacyMinAndMaxValues();
  }

  setupModernRange() {
    this.visibleInputs = {
      min: this.querySelector('[data-price-visible="min"]'),
      max: this.querySelector('[data-price-visible="max"]'),
    };
    this.hiddenInputs = {
      min: this.querySelector('[data-price-hidden="min"]'),
      max: this.querySelector('[data-price-hidden="max"]'),
    };
    this.rangeInputs = {
      min: this.querySelector('[data-price-range="min"]'),
      max: this.querySelector('[data-price-range="max"]'),
    };
    this.activeTrack = this.querySelector('[data-price-track]');

    this.rangeMaxDisplay =
      this.modernRange.dataset.rangeMaxDisplay || this.visibleInputs.max?.getAttribute('placeholder') || '0';

    const formatTokens = this.getFormatTokens(this.rangeMaxDisplay);
    this.groupSeparator = formatTokens.groupSeparator;
    this.decimalSeparator = formatTokens.decimalSeparator;
    this.decimals = formatTokens.decimals;

    this.rangeMax = this.parseDisplayValue(this.rangeMaxDisplay);
    if (!Number.isFinite(this.rangeMax) || this.rangeMax <= 0) {
      this.rangeMax = 0;
    }

    this.step = this.decimals > 0 ? 1 / 10 ** this.decimals : 1;

    Object.entries(this.visibleInputs).forEach(([type, input]) => {
      if (!input) return;

      const hiddenInput = this.hiddenInputs[type];
      if (hiddenInput && !hiddenInput.name && input.name) {
        hiddenInput.name = input.name;
      }

      if (input.name) {
        input.dataset.formName = input.name;
        input.removeAttribute('name');
      }

      input.addEventListener('keydown', this.onKeyDown.bind(this));
      input.addEventListener('input', this.onVisibleInput.bind(this));
      input.addEventListener('change', this.onVisibleChange.bind(this));
      input.addEventListener('blur', this.onVisibleChange.bind(this));
    });

    Object.values(this.rangeInputs).forEach((input) => {
      if (!input) return;
      input.min = '0';
      input.max = String(this.rangeMax);
      input.step = String(this.step);
      input.addEventListener('input', this.onSliderInput.bind(this));
      input.addEventListener('change', this.onSliderChange.bind(this));
    });

    this.syncModernRangeFromDisplay();
  }

  getFormatTokens(displayValue) {
    const value = String(displayValue || '');
    const spaceMatch = value.match(/\d([\s\u00A0])\d{3}/);
    const cleanedValue = value.replace(/[^\d,.\s\u00A0-]/g, '');

    if (cleanedValue.includes(',') && cleanedValue.includes('.')) {
      const lastComma = cleanedValue.lastIndexOf(',');
      const lastDot = cleanedValue.lastIndexOf('.');
      const decimalSeparator = lastComma > lastDot ? ',' : '.';

      return {
        decimalSeparator,
        groupSeparator: decimalSeparator === ',' ? '.' : ',',
        decimals: cleanedValue.split(decimalSeparator).pop().length,
      };
    }

    if (spaceMatch) {
      return {
        decimalSeparator: null,
        groupSeparator: spaceMatch[1],
        decimals: 0,
      };
    }

    const commaCount = (cleanedValue.match(/,/g) || []).length;
    const dotCount = (cleanedValue.match(/\./g) || []).length;

    if (commaCount) {
      const [integerPart, decimalPart] = cleanedValue.split(',');
      const hasDecimalPart = commaCount === 1 && decimalPart && decimalPart.length <= 2;

      return {
        decimalSeparator: hasDecimalPart ? ',' : null,
        groupSeparator: hasDecimalPart ? null : ',',
        decimals: hasDecimalPart ? decimalPart.length : 0,
      };
    }

    if (dotCount) {
      const [integerPart, decimalPart] = cleanedValue.split('.');
      const hasDecimalPart = dotCount === 1 && decimalPart && decimalPart.length <= 2;

      return {
        decimalSeparator: hasDecimalPart ? '.' : null,
        groupSeparator: hasDecimalPart ? null : '.',
        decimals: hasDecimalPart ? decimalPart.length : 0,
      };
    }

    return {
      decimalSeparator: null,
      groupSeparator: null,
      decimals: 0,
    };
  }

  normalizeNumericString(value) {
    const sanitized = String(value ?? '').replace(/[^\d,.\-]/g, '').trim();
    if (!sanitized) return '';

    const commaCount = (sanitized.match(/,/g) || []).length;
    const dotCount = (sanitized.match(/\./g) || []).length;

    if (commaCount && dotCount) {
      const lastComma = sanitized.lastIndexOf(',');
      const lastDot = sanitized.lastIndexOf('.');
      const decimalSeparator = lastComma > lastDot ? ',' : '.';
      const thousandsSeparator = decimalSeparator === ',' ? '.' : ',';

      return sanitized.replace(new RegExp(`\\${thousandsSeparator}`, 'g'), '').replace(decimalSeparator, '.');
    }

    if (commaCount) {
      if (commaCount > 1) return sanitized.replace(/,/g, '');

      const [integerPart, decimalPart] = sanitized.split(',');
      if (decimalPart && decimalPart.length <= 2) return `${integerPart.replace(/,/g, '')}.${decimalPart}`;

      return sanitized.replace(/,/g, '');
    }

    if (dotCount) {
      if (dotCount > 1) return sanitized.replace(/\./g, '');

      const [integerPart, decimalPart] = sanitized.split('.');
      if (decimalPart && decimalPart.length <= 2) return sanitized;

      return sanitized.replace(/\./g, '');
    }

    return sanitized;
  }

  parseDisplayValue(value) {
    const normalizedValue = this.normalizeNumericString(value);
    if (!normalizedValue) return Number.NaN;

    const parsedValue = Number(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : Number.NaN;
  }

  toRawValue(value) {
    if (!Number.isFinite(value)) return '';

    if (this.decimals === 0) return `${Math.round(value)}`;

    return value.toFixed(this.decimals).replace(/\.?0+$/, '');
  }

  formatDisplayValue(value) {
    if (!Number.isFinite(value)) return '';

    let [integerPart, decimalPart = ''] = value.toFixed(this.decimals).split('.');

    if (this.groupSeparator) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, this.groupSeparator);
    }

    if (this.decimals === 0) return integerPart;

    decimalPart = decimalPart.replace(/0+$/, '');
    return decimalPart ? `${integerPart}${this.decimalSeparator || '.'}${decimalPart}` : integerPart;
  }

  getDisplayValue(type, value) {
    if (type === 'min' && value <= 0) return '';
    if (type === 'max' && value >= this.rangeMax) return '';

    return this.formatDisplayValue(value);
  }

  clampModernValues(minValue, maxValue, activeType) {
    let nextMin = Number.isFinite(minValue) ? minValue : 0;
    let nextMax = Number.isFinite(maxValue) ? maxValue : this.rangeMax;

    nextMin = Math.max(0, Math.min(nextMin, this.rangeMax));
    nextMax = Math.max(0, Math.min(nextMax, this.rangeMax));

    if (activeType === 'min' && nextMin > nextMax) {
      nextMin = nextMax;
    } else if (activeType === 'max' && nextMax < nextMin) {
      nextMax = nextMin;
    } else if (nextMin > nextMax) {
      nextMax = nextMin;
    }

    return { min: nextMin, max: nextMax };
  }

  updateRangeTrack(minValue, maxValue) {
    if (!this.activeTrack || this.rangeMax <= 0) return;

    const start = (minValue / this.rangeMax) * 100;
    const end = (maxValue / this.rangeMax) * 100;

    this.activeTrack.style.left = `${start}%`;
    this.activeTrack.style.width = `${Math.max(end - start, 0)}%`;

    if (this.rangeInputs.min && this.rangeInputs.max) {
      this.rangeInputs.min.style.zIndex = minValue >= maxValue - this.step ? '3' : '2';
      this.rangeInputs.max.style.zIndex = '2';
    }
  }

  applyModernValues({ min, max }, { updateVisible = true } = {}) {
    if (this.hiddenInputs.min) {
      this.hiddenInputs.min.value = min > 0 ? this.toRawValue(min) : '';
    }

    if (this.hiddenInputs.max) {
      this.hiddenInputs.max.value = max < this.rangeMax ? this.toRawValue(max) : '';
    }

    if (this.rangeInputs.min) this.rangeInputs.min.value = `${min}`;
    if (this.rangeInputs.max) this.rangeInputs.max.value = `${max}`;

    this.updateRangeTrack(min, max);

    if (updateVisible) {
      if (this.visibleInputs.min) this.visibleInputs.min.value = this.getDisplayValue('min', min);
      if (this.visibleInputs.max) this.visibleInputs.max.value = this.getDisplayValue('max', max);
    }
  }

  getCurrentModernValues() {
    const minFromHidden = this.parseDisplayValue(this.hiddenInputs.min?.value);
    const maxFromHidden = this.parseDisplayValue(this.hiddenInputs.max?.value);

    return {
      min: Number.isFinite(minFromHidden) ? minFromHidden : 0,
      max: Number.isFinite(maxFromHidden) ? maxFromHidden : this.rangeMax,
    };
  }

  syncModernRangeFromDisplay() {
    const initialMinValue = this.parseDisplayValue(this.visibleInputs.min?.value);
    const initialMaxValue = this.parseDisplayValue(this.visibleInputs.max?.value);
    const nextValues = this.clampModernValues(initialMinValue, initialMaxValue, 'max');

    this.applyModernValues(nextValues);
  }

  onVisibleInput(event) {
    const activeType = event.currentTarget.dataset.priceVisible;
    const currentValues = this.getCurrentModernValues();
    const parsedValue = this.parseDisplayValue(event.currentTarget.value);

    const nextValues = this.clampModernValues(
      activeType === 'min' ? parsedValue : currentValues.min,
      activeType === 'max' ? parsedValue : currentValues.max,
      activeType
    );

    this.applyModernValues(nextValues, { updateVisible: false });
  }

  onVisibleChange(event) {
    const activeType = event.currentTarget.dataset.priceVisible;
    const currentValues = this.getCurrentModernValues();
    const parsedValue = this.parseDisplayValue(event.currentTarget.value);

    const nextValues = this.clampModernValues(
      activeType === 'min' ? parsedValue : currentValues.min,
      activeType === 'max' ? parsedValue : currentValues.max,
      activeType
    );

    this.applyModernValues(nextValues);
  }

  onSliderInput(event) {
    const activeType = event.currentTarget.dataset.priceRange;
    const minValue = Number(this.rangeInputs.min?.value || 0);
    const maxValue = Number(this.rangeInputs.max?.value || this.rangeMax);
    const nextValues = this.clampModernValues(minValue, maxValue, activeType);

    this.applyModernValues(nextValues);
  }

  onSliderChange(event) {
    this.onSliderInput(event);
  }

  onLegacyRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setLegacyMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setLegacyMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    window.location.reload();
  }
}

customElements.define('facet-remove', FacetRemove);

function applyBigItems(pattern, startIndex = 0) {
  const pg = document.getElementById('product-grid');
  if (!pg) return;

  const items = Array.from(pg.querySelectorAll('.grid__item'));
  if (!items.length) return;


  items.forEach(el => el.classList.remove('item-big'));

  const bigPositions = [];
  let idx = startIndex;
  let step = 0;
  while (idx < items.length) {
    bigPositions.push(idx);
    idx += pattern[step % pattern.length];
    step++;
  }

  const promoItems = items.filter(el => el.hasAttribute('data-promotion'));

  if (!promoItems.length) return;

  const result = new Array(items.length).fill(null);
  const extras = [];
  promoItems.forEach((promo, i) => {
    const pos = bigPositions[i];
    if (pos !== undefined && pos < result.length) {
      result[pos] = promo;
    } else {
      extras.push(promo);
    }
  });

  const remaining = items.filter(el => !promoItems.includes(el));

  let remIdx = 0;
  for (let i = 0; i < result.length; i++) {
    if (result[i] === null) {
      if (remIdx < remaining.length) {
        result[i] = remaining[remIdx++];
      } else {
        result[i] = extras.shift() || null;
      }
    }
  }

  result.forEach(el => {
    if (el) pg.appendChild(el);
  });

  promoItems.forEach(el => el.classList.add('item-big'));
}

function applyLayout(option) {
  const pg = document.getElementById('product-grid');
  if (!pg) return;

  // Sync icons
  document.querySelectorAll('[data-change-layout="true"]').forEach(btn => btn.classList.remove('active'));
  const optionNumber = option.replace('option-', '');
  const activeButtons = document.querySelectorAll(`.facets-vertical-changelayout__option-${optionNumber}`);
  activeButtons.forEach(btn => btn.classList.add('active'));

  localStorage.setItem('productLayout', option);

  pg.querySelectorAll('.grid__item.item-big').forEach(el => el.classList.remove('item-big'));
  pg.classList.remove(
    'grid--2-col-desktop',
    'grid--3-col-desktop',
    'grid--4-col-desktop',
    'grid--2-col-tablet-down',
    'grid--1-col-tablet-down',
    'gap-y-10',
    'gap-y-5',
    'gap-y-6'
  );

  if (option === 'option-1') {
    pg.classList.add('grid--2-col-desktop', 'gap-y-10');
  }

  if (option === 'option-2') {
    pg.classList.add('grid--3-col-desktop','gap-y-6');
    applyBigItems([6, 4, 5, 5, 4], 3);
  }

  if (option === 'option-3') {
    pg.classList.add('grid--4-col-desktop', 'gap-y-5');
    applyBigItems([8, 8, 5], 4);
  }

  if (option === 'option-4') {
    pg.classList.add('grid--2-col-tablet-down', 'gap-y-6');
  }

  if (option === 'option-5') {
    pg.classList.add('grid--1-col-tablet-down', 'gap-y-10');
  }
}

let originalHeights = {};

function syncFilterAndGridHeight() {
  const filter = document.querySelector('#FacetsWrapperDesktop');
  const grid = document.querySelector('#ProductGridContainer');
  if (!filter || !grid) return;

  if (!originalHeights.filter) originalHeights.filter = filter.offsetHeight;
  if (!originalHeights.grid) originalHeights.grid = grid.offsetHeight;


  filter.style.minHeight = '';
  grid.style.minHeight = '';

  const filterHeight = filter.offsetHeight + 60;
  const gridHeight = grid.offsetHeight;
  const maxHeight = Math.max(filterHeight, gridHeight);

  if (filterHeight > gridHeight || filterHeight > originalHeights.grid) {
    filter.style.minHeight = `${filterHeight}px`;
    grid.style.minHeight = `${filterHeight}px`;

    document.documentElement.style.setProperty('--filter-height', `${filterHeight}px`);
    document.documentElement.style.setProperty('--productgrid-height', `${filterHeight}px`);
  } else {
    filter.style.minHeight = '';
    grid.style.minHeight = '';

    document.documentElement.style.removeProperty('--filter-height');
    document.documentElement.style.removeProperty('--productgrid-height');
  }
}

const verticalFacets = document.querySelectorAll('.facets__disclosure-vertical');
verticalFacets.forEach((facet) => {
  facet.addEventListener('click', () => {
    setTimeout(syncFilterAndGridHeight, 100);
  });
});

window.addEventListener('resize', () => setTimeout(syncFilterAndGridHeight, 300));

setTimeout(syncFilterAndGridHeight, 500);

document.addEventListener('DOMContentLoaded', () => {
  const applyDefaultLayout = (firstLoad = true) => {
    const screenWidth = window.innerWidth;

    if (firstLoad) {
      localStorage.setItem('productLayout', '');
    }

    document.querySelectorAll('[data-change-layout="true"]').forEach(opt =>
      opt.classList.remove('active')
    );

    if (screenWidth > 990) {
      const option2 = document.querySelector('.facets-vertical-changelayout__option-2');
      if (option2) {
        option2.classList.add('active');
        applyLayout('option-2');
        localStorage.setItem('productLayout', 'option-2');
      }
    } else {
      const option4 = document.querySelector('.facets-vertical-changelayout__option-4');
      if (option4) {
        option4.classList.add('active');
        applyLayout('option-4');
        localStorage.setItem('productLayout', 'option-4');
      }
    }
  };

  applyDefaultLayout();
  const fwd = document.querySelector('#FacetsWrapperDesktop');
  if (fwd) {
    let totalFilterHeight = fwd.offsetHeight;
    document.documentElement.style.setProperty('--filter-height', `${totalFilterHeight}px`);
  }
  const pgc = document.querySelector('#ProductGridContainer');
  if (pgc) {
    let totalGridHeight = pgc.offsetHeight;
    document.documentElement.style.setProperty('--productgrid-height', `${totalGridHeight}px`);
  }

  window.addEventListener('resize', () => {
    applyDefaultLayout();
  });
});

/**
 * Global helpers for facet Interactions
 */
window.toggleFilter = function(label) {
  const container = label.nextElementSibling;
  const willOpen = container?.classList.contains('hidden');

  document.querySelectorAll('.facet-filters__label.active').forEach((activeLabel) => {
    if (activeLabel !== label) activeLabel.classList.remove('active');
  });

  document.querySelectorAll('.facet-filters__dropdown.active').forEach((activeDropdown) => {
    if (activeDropdown !== container) {
      activeDropdown.classList.remove('active');
      activeDropdown.classList.add('hidden');
    }
  });

  if (container && container.classList.contains('select')) {
    container.classList.toggle('hidden', !willOpen);
    container.classList.toggle('active', willOpen);
  }

  if (label) label.classList.toggle('active', willOpen);
};

document.addEventListener('click', (event) => {
  // Toggle custom filter dropdowns
  const toggle = event.target.closest('.js-facet-toggle');
  if (toggle) {
    window.toggleFilter(toggle);
    return;
  }

  // Close mobile facets apply button
  const closeMobile = event.target.closest('.js-close-mobile-facets');
  if (closeMobile) {
    const form = closeMobile.closest('form');
    const drawer = closeMobile.closest('.mobile-facets__wrapper');
    
    if (drawer) {
      const summary = drawer.querySelector('summary');
      if (summary) summary.click();
    }

    if (form && form.id === 'FacetFiltersFormMobile') {
      const facetFormElement = form.closest('facet-filters-form');
      if (facetFormElement) {
        const searchParams = facetFormElement.createSearchParams(form);
        setTimeout(() => {
           FacetFiltersForm.renderPage(searchParams);
        }, 100);
      }
    }
    return;
  }

  const closeMobileDrawer = event.target.closest('.js-close-mobile-facets-drawer');
  if (closeMobileDrawer) {
    const disclosure = closeMobileDrawer.closest('.mobile-facets__disclosure');
    if (disclosure?.hasAttribute('open')) {
      disclosure.removeAttribute('open');
      disclosure.classList.remove('menu-opening');
    }
    return;
  }

  // Sort Menu Items selection
  const sortItem = event.target.closest('.sort-menu-item');
  if (sortItem) {
    const value = sortItem.getAttribute('data-value');
    const form = sortItem.closest('form');
    if (form) {
      const select = form.querySelector('select[name="sort_by"]');
      if (select) {
        select.value = value;

        if (form.id === 'FacetFiltersFormMobile') {
          // Update visual state for mobile sort items
          const sortContainer = sortItem.closest('ul');
          sortContainer.querySelectorAll('.sort-menu-item').forEach(item => item.classList.remove('active'));
          sortItem.classList.add('active');
          
          sortContainer.querySelectorAll('.svg-wrapper').forEach(svg => svg.classList.add('hidden'));
          sortItem.querySelector('.svg-wrapper')?.classList.remove('hidden');
          
          // Toggle input checked state for visual sync in mobile_layout
          const input = sortItem.querySelector('input');
          if (input) {
            sortContainer.querySelectorAll('input').forEach(i => i.checked = false);
            input.checked = true;
          }
        } else {
          select.dispatchEvent(new Event('change', { bubbles: true }));
          const label = form.querySelector('.js-facet-toggle');
          const dropdown = form.querySelector('.facet-filters__dropdown');
          label?.classList.remove('active');
          dropdown?.classList.remove('active');
          dropdown?.classList.add('hidden');
          
          const facetFormElement = sortItem.closest('facet-filters-form');
          if (facetFormElement && typeof facetFormElement.onSubmitHandler === 'function') {
            facetFormElement.onSubmitHandler({
              target: select,
              preventDefault: () => {}
            });
          } else {
            form.submit();
          }
        }
      }
    }
    return;
  }

  // Close dropdowns when clicking outside
  const isFacetField = event.target.closest('.facet-filters__field');
  if (!isFacetField) {
    document.querySelectorAll('.facet-filters__label.active, .facet-filters__field .select.active').forEach(el => {
      el.classList.remove('active');
      if (el.classList.contains('facet-filters__dropdown')) {
        el.classList.add('hidden');
      }
    });
  }
});

function initCustomThemeMobileFacetAccordions() {
  if (document.documentElement.dataset.themeStyle === 'default') return;

  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest('#FacetFiltersFormMobile .mobile-facets__details > summary');
      if (!summary) return;

      const details = summary.closest('.mobile-facets__details');
      if (!details || !details.closest('menu-drawer')) return;

      const parentMenuElement = details.closest('.has-submenu');

      event.preventDefault();
      event.stopImmediatePropagation();

      const willOpen = !details.hasAttribute('open');
      summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      parentMenuElement?.classList.remove('submenu-open');

      if (willOpen) {
        details.setAttribute('open', '');
        details.classList.add('menu-opening');
        return;
      }

      details.classList.remove('menu-opening');
      details.removeAttribute('open');
    },
    true
  );
}

initCustomThemeMobileFacetAccordions();
